import * as api from '../api/configs'
import { ConfigInterface } from '../Interfaces/ConfigsInterface'
import { actionCreatorAsync, AsyncAction } from './index'

export function getConfigs(existingConfig?: ConfigInterface): AsyncAction<ConfigInterface> {
  return actionCreatorAsync<ConfigInterface>('GET_CONFIGS', async () => {
    return existingConfig ? Promise.resolve(existingConfig) : api.getConfigs()
  })
}
